import { render, staticRenderFns } from "./NextPageSVG.vue?vue&type=template&id=549ea041"
import script from "./NextPageSVG.vue?vue&type=script&lang=js"
export * from "./NextPageSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports